export default __webpack_public_path__ + "static/media/23.afb8dce0.jpg";